module.exports = __webpack_public_path__ + "img/contact_3.c2eb5d15.jpg";